import { render } from "./InfoMessageDialog.vue?vue&type=template&id=5da657f8&scoped=true"
import script from "./InfoMessageDialog.vue?vue&type=script&lang=js"
export * from "./InfoMessageDialog.vue?vue&type=script&lang=js"

import "./InfoMessageDialog.vue?vue&type=style&index=0&id=5da657f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da657f8"]])

export default __exports__